import {
    Card,
    CardContent,
    CardMedia,
    IconButton,
    Chip, Box, Button, Typography, Grid
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const PlayerCard = ({ item, viewPlayer, editPlayer, onPlayerDelete }) => {
    return (
        <Card sx={{
            height: '100%',
            display: "flex",
            flexDirection: "column",
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            transition: 'transform 0.3s, box-shadow 0.3s',
            '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
            }
        }}>
            <CardMedia
                component="img"
                sx={{
                    height: 180,
                    objectFit: 'cover',
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px'
                }}
                image={item.player_photo || '/placeholder-player.jpg'}
                alt={item.player_name}
            />
            <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{
                    fontWeight: 600,
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    {item.player_name}
                    <Chip
                        label={item.status}
                        size="small"
                        color={item.status === 'Active' ? 'success' : 'default'}
                        sx={{ ml: 1 }}
                    />
                </Typography>

                <Grid container spacing={1} sx={{ mb: 1 }}>
                    <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                            <Box component="span" sx={{ fontWeight: 500 }}>Position:</Box> {item.position}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                            <Box component="span" sx={{ fontWeight: 500 }}>Team:</Box> {item.team_name}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                            <Box component="span" sx={{ fontWeight: 500 }}>College:</Box> {item.college || 'N/A'}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                            <Box component="span" sx={{ fontWeight: 500 }}>Games:</Box> {item.number_of_games ?? 'N/A'}
                        </Typography>
                    </Grid>
                </Grid>

                <Box sx={{
                    backgroundColor: 'rgba(0,0,0,0.03)',
                    p: 1.5,
                    borderRadius: '8px',
                    mb: 2
                }}>
                    <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 500 }}>Draft Price:</span>
                        <span>${item.draft_price?.toLocaleString()}</span>
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 500 }}>Stock Value:</span>
                        <span style={{ color: '#4caf50', fontWeight: 600 }}>
                            ${item.new_stock_value?.toLocaleString()}
                        </span>
                    </Typography>
                    {item.grade && (
                        <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ fontWeight: 500 }}>Grade:</span>
                            <span style={{
                                fontWeight: 600,
                                color: item.grade >= 90 ? '#4caf50' :
                                    item.grade >= 80 ? '#2196f3' :
                                        item.grade >= 70 ? '#ff9800' : '#f44336'
                            }}>
                                {item.grade}
                            </span>
                        </Typography>
                    )}
                </Box>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderTop: '1px solid rgba(0,0,0,0.08)',
                    pt: 1.5
                }}>
                    <Button
                        startIcon={<VisibilityIcon />}
                        onClick={() => viewPlayer(item)}
                        size="small"
                        sx={{ textTransform: 'none' }}
                    >
                        View
                    </Button>
                    <Box>
                        <IconButton
                            onClick={() => editPlayer(item)}
                            size="small"
                            sx={{
                                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                mr: 1,
                                '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.15)' }
                            }}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            onClick={() => onPlayerDelete(item)}
                            size="small"
                            sx={{
                                backgroundColor: 'rgba(211, 47, 47, 0.08)',
                                '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.15)' }
                            }}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default PlayerCard;